import React from "react";
import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'
import InputGroup from 'react-bootstrap/InputGroup'
import Form from 'react-bootstrap/Form'
import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import './index.css'


const Contact = (props) => {
    const navigate = useNavigate()
    const location = useLocation()

    return (
        <div className="" style={{ paddingTop: '4rem', height: '100vh' }}>
            <div className="container d-flex flex-row align-items-center justify-content-center" style={{ maxWidth: '800px' }}>
                <Card style={{ width: '34rem' }} className="px-4 pb-4">
                    <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                        <Card.Title style={{ paddingTop: '15px' }} className="fw-bold mb-4">Contact</Card.Title>
                        <div className="fw my-1 text-start w-100">Thank you for being part of this passion project. For any comments, questions, concerns, feel free to reach out at: </div>
                        <div className="fw-light mt-3 w-100 text-start">Email: kurtisgassewitz@gmail.com</div>
                        <div className="fw-light w-100 text-start">instagram: @downhillmtbfantasy</div>
                    </Card.Body>
                </Card>
            </div>
        </div>
    );
}

export default Contact;